import React from 'react'
import { componentsConfig as rest } from 'srs.sharedcomponents/lib/esm/components/config'
import WelcomeBuilder from 'srs.sharedcomponents/lib/esm/components/organisms/Welcome/BuilderContent/WelcomeBuilder'
import FooterBuilderComponent from 'srs.sharedcomponents/lib/esm/components/organisms/Footer/FooterBuilder/FooterBuilder'
import HeaderComponent from '../Header'
import MySubscriptions from '../mySubscriptions/mySubscriptions'
import { useAppSelector } from 'srs.sharedcomponents/lib/esm/redux/hooks'
import { region } from 'srs.sharedcomponents/lib/esm/redux/slices/welcomeSlice'
import LoanCheckoutComponent from 'srs.sharedcomponents/lib/esm/shared-components/srs.loanCheckout.component'
import { BusinessRegion } from 'srs.sharedcomponents/lib/esm/utils/enums'
import LoanRequestForm from '../LoanFormCheckout'

const LoanComponentSelector = (props: any) => {
  const regionData = useAppSelector(region)
  const regionName = regionData?.shortName ? regionData.shortName : ''
  const SelectedComponent =
    regionName === BusinessRegion.Australia
      ? LoanRequestForm
      : LoanCheckoutComponent
  return React.createElement(SelectedComponent, props)
}

const componentsConfig = {
  ...rest,
  WelcomeContent: WelcomeBuilder,
  Header: HeaderComponent,
  FooterContent: FooterBuilderComponent,
  MySubscriptions: MySubscriptions,
  LoanCheckoutComponent: LoanComponentSelector,
}

export { componentsConfig }
